export default __webpack_public_path__ + "static/media/20200618_133929.e78b9081.jpg";